__turbopack_context__.v({
  "my_list_confirm_removal_modal": "RlBUvG_my_list_confirm_removal_modal",
  "my_list_confirm_removal_modal_buttons": "RlBUvG_my_list_confirm_removal_modal_buttons",
  "my_list_confirm_removal_modal_inner": "RlBUvG_my_list_confirm_removal_modal_inner",
  "my_list_confirm_removal_modal_text": "RlBUvG_my_list_confirm_removal_modal_text",
});
